<template>
  <div>
    <div class="container-fluid py-3 bg-white mk-businesscustomerinformation">
      <div class="row">
        <div class="col-12">
          <h1 class="mb-0">Add a Customer</h1>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row mt-4 pt-3">
        <div
          class="col-12 col-md-6 bg-white mx-auto pt-5 pb-3 d-flex justify-content-between align-items-center"
        >
          <h2 class="mb-0">Customer Details</h2>
          <p class="mb-0">Step 2</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 bg-white mx-auto py-3">
          <hr />
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-md-6 mx-auto bg-white py-3">
          <el-form
            :model="user"
            v-for="(user, index) in business.users"
            :key="index"
            :rules="rules"
            label-position="left"
            ref="customer-forms"
            label-width="120px"
            class="w-100 mx-auto row flex-column justify-content-center"
          >
            <el-form-item label="First Name" prop="first_name">
              <el-input v-model="user.first_name"></el-input>
            </el-form-item>

            <el-form-item label="Last Name" prop="last_name">
              <el-input v-model="user.last_name"></el-input>
            </el-form-item>

            <el-form-item label="Email" prop="email">
              <el-input v-model="user.email"></el-input>
            </el-form-item>
            <el-form-item label="Date of Birth" prop="date_of_birth">
              <el-date-picker
                v-model="user.date_of_birth"
                value-format="yyyy-MM-dd"
                format="dd/MM/yyyy"
                type="date"
                placeholder="Pick a day"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Phone" prop="phone_number">
              <div class="form-group row">
                <div class="col-md-12">
                  <vue-tel-input
                    mode="international"
                    class="w-100 form-control-borders"
                    :onlyCountries="['AU', 'GB', 'NZ', 'US']"
                    style="min-height:38px !important"
                    v-model="user.phone_number"
                  ></vue-tel-input>
                </div>
              </div>
            </el-form-item>

            <div class="row">
              <div class="col-12">
                <hr />
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row mb-4">
        <div class="col-12 col-md-6 bg-white mx-auto">
          <div class="form-group col-12 d-flex">
            <el-button type="primary" class="mr-auto btn-light-blue" plain @click="onAdd">
              Add Customer
              <i class="fas fa-plus mr-2"></i>
            </el-button>
          </div>

          <div class="col-md-12">
            <hr />
          </div>

          <div class="form-group col-md-12 d-flex justify-content-between">
            <el-button
              class="btn-light-blue"
              style="margin-top: 12px;"
              @click="onPrevious"
              plain
            >Back</el-button>

            <el-button
              style="margin-top: 12px;"
              class="ml-auto"
              @click="onNext"
              type="primary"
            >Next step</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Business from "../../../models/Business";

export default {
  props: {
    business_types: {
      type: Array
    },
    initial_business: {
      type: Business
    }
  },
  data() {
    return {
      //
      business: this.initial_business,
      rules: {
        first_name: [
          {
            required: true,
            message: "Please choose a name",
            trigger: "blur"
          }
        ],
        last_name: [
          {
            required: true,
            message: "Please choose a name",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            type: "email",
            message: "Please choose a valid email",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    onAdd() {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < 12; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      this.business.users.push({
        roles: ["user"],
        active: true,
        password: result,
        password_confirmation: result
      });
    },
    onNext() {
      let passes = true;

      for (let i = 0; i < this.$refs["customer-forms"].length; i++) {
        this.$refs["customer-forms"][i].validate(valid => {
          if (!valid) {
            passes = false;
          }
        });
      }

      if (passes) {
        this.$emit("next", this.business);
      } else {
        this.$message({
          type: "error",
          message: "Looks like there was some invalid data."
        });
      }
    },
    onPrevious() {
      this.$emit("previous", this.business);
    }
  }
};
</script>